export const name: string = 'On Data Retrieving';
export const group = 'Misc.';
export const moduleName: string = 'pdc-widget-on-data-retrieving';
export const icon: string = 'flash';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'pdc-widget-on-data-retrieving';
